export default "__VITE_PUBLIC_ASSET__fc373dd0__"